import { CircularProgress } from "@mui/material";
import React from "react";
import { Chart } from "react-google-charts";
import { Get } from "../../service/getway";
import moment from "moment";
// import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';


export const options = {
  chart: {
    title: "Number of sites per Zone",
    subtitle: "",
    colors: ["#33FF80", "#FF9033", "#FF3333"],
  },
  hAxis: {
    title: "Total number of sites",
    minValue: 0,
    titleTextStyle: {
      color: "#000",
      fontName: "sans-serif",
      fontSize: 50,
      bold: true,
      italic: false
  }
  },
  vAxis: {
    title: "Zone",
    titleTextStyle: {
      color: "#000",
      fontName: "sans-serif",
      fontSize: 50,
      bold: true,
      italic: false
  }
  },
  bars: "horizontal",
  axes: {
    y: {
      0: { side: "right" },
    },
  },
  dataLabels: {
    enabled: true,
    color: "#000",
    fontSize: 50,
    bold: true,
    format: "#",
  },
  
};

const handleSelect = (chartWrapper) => {
  // console.log(chartWrapper, "sdfghjklkjhgfdsdf");
};




export function Sidebar({loadshedingdata}) {

  const [sites, setsites] = React.useState([]);
  const [siteDetails, setSiteDetails] = React.useState([])
  const [selectedBar, setSelectedBar] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const {token}=  useSelector((state) => state.auth)
  const history = useHistory();

  React.useEffect(() => {
     fetchEventData();
     // Set interval to fetch data every 10 minutes (600,000 milliseconds)
    const intervalId = setInterval(fetchEventData, 600000);
    // Clean up the interval when the component is unmounted
    return () => clearInterval(intervalId);

  }, []);

const fetchEventData = async () => {
  try {
    setLoading(true);

    const site_object = [];
    const response = await Get("/site", token);
    const { data } = response.data;

    // Filter out sites without valid SerialNo
    const validSites = data.filter(
      (site) => site.SerialNo && site.SerialNo !== "" && site.SerialNo !== null
    );

    const sitestatus_url = "https://atlas-ov.sys.echosp.link/api/status1";
    const status_response = await Get(sitestatus_url, token);
    const statusData = Object.values(status_response.data || {});

    // Group statuses by devid
    const statusMap = statusData.reduce((acc, item) => {
      const { devid, status } = item;
      if (!acc[devid]) acc[devid] = [];
      acc[devid].push(status);
      return acc;
    }, {});

    // Compute site status based on rules
    const computedStatus = Object.entries(statusMap).map(([devid, statuses]) => {
      const upCount = statuses.filter((s) => s === "up").length;
      const downCount = statuses.filter((s) => s === "down").length;
      let siteStatus = "down";

      if (upCount >= 2) {
        siteStatus = "up";
      } else if (downCount >= 2 || (upCount === 1 && downCount === 1)) {
        siteStatus = "updown";
      } else if (upCount === 1 && statuses.length === 1) {
        siteStatus = "updown"; // single interface flicker case
      }

      return { devid, siteStatus };
    });

    // Merge site and status data
    const statusMapFinal = Object.fromEntries(
      computedStatus.map(({ devid, siteStatus }) => [devid, siteStatus])
    );

    const siteData = validSites.map((site) => {
      const siteStatus = statusMapFinal[site.SerialNo] || "down";
      const matchedStatus = statusData.find((s) => s.devid === site.SerialNo);

      return {
        devid: site.SerialNo,
        devname: site.SiteName,
        site_status: siteStatus,
        count: statusMap[site.SerialNo]?.length || 0,
        date: matchedStatus?._col0 || "",
        interface: matchedStatus?.interface || "",
        zone: site.Zone,
        siteName: site.SiteName,
        underlay1: site.Underlay1,
        underlay2: site.Underlay2,
      };
    });

    // Store and set state
    localStorage.setItem("dash_data", JSON.stringify(siteData));
    setSiteDetails(siteData);
    setsites(validSites);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};


const fetchEventData5 = async () => {
  try {
    setLoading(true);

    // Fetch both APIs concurrently
    const [siteResponse, statusResponse] = await Promise.all([
      Get("/site", token),
      Get("https://atlas-ov.sys.echosp.link/api/status1", token),
    ]);

    // 🧹 Clean & normalize site data — remove invalid SerialNos (null, empty, whitespace)
    const sites = (siteResponse.data?.data || [])
      .filter(
        (s) =>
          s.SerialNo !== null &&
          typeof s.SerialNo === "string" &&
          s.SerialNo.trim() !== ""
      )
      .map((s) => ({
        ...s,
        SerialNo: s.SerialNo.trim().toUpperCase(),
      }));

    // 🧩 Normalize and clean status data — skip entries with no devid
    const statusData = Object.values(statusResponse.data || {}).filter(
      (item) => item.devid && String(item.devid).trim() !== ""
    );

    // Group interface statuses by device ID
    const deviceStatuses = statusData.reduce((acc, rawItem) => {
      const devid = String(rawItem.devid || "").trim().toUpperCase();
      if (!devid) return acc;
      if (!acc[devid]) acc[devid] = [];
      acc[devid].push({ ...rawItem, status: rawItem.status?.toLowerCase() });
      return acc;
    }, {});

    // Compute summarized status per device
    const deviceStatusSummary = {};
    Object.entries(deviceStatuses).forEach(([devid, interfaces]) => {
      const upCount = interfaces.filter((i) => i.status === "up").length;
      const downCount = interfaces.filter((i) => i.status === "down").length;

      let overallStatus = "down";
      if (upCount > 0 && downCount > 0) overallStatus = "updown";
      else if (upCount > 0 && downCount === 0) overallStatus = "up";

      deviceStatusSummary[devid] = {
        devid,
        devname: interfaces[0]?.devname || "",
        status: overallStatus,
        count: upCount,
        date: interfaces[0]?._col0 || "",
        interface: interfaces.map((i) => i.interface).join(", "),
      };
    });

    // Merge site info with summarized status
    const siteObjects = sites.map((site) => {
      const siteId = site.SerialNo;
      const match = deviceStatusSummary[siteId];

      return {
        devid: site.SerialNo,
        devname: match?.devname || site.SiteName,
        site_status: match?.status || "down",
        date: match?.date || "",
        interface: match?.interface || "",
        count: match?.count || 0,
        zone: site.Zone,
        siteName: site.SiteName,
        underlay1: site.Underlay1,
        underlay2: site.Underlay2,
      };
    });

    // Filter out unwanted or specific devices
    const filteredSites = siteObjects.filter(
      (s) => s.devid !== "FGT40FTK2209A1L9"
    );

    // Deduplicate by device ID
    const uniqueList = Object.values(
      filteredSites.reduce((acc, site) => {
        acc[site.devid] = site;
        return acc;
      }, {})
    );

    // Persist & update state
    localStorage.setItem("dash_data", JSON.stringify(uniqueList));
    setSiteDetails(uniqueList);
    setsites(sites);
  } catch (error) {
    console.error("❌ Error fetching event data:", error);
  } finally {
    setLoading(false);
  }
};
	

const fetchEventData4 = async () => {
  try {
    setLoading(true);

    // Fetch both APIs concurrently
    const [siteResponse, statusResponse] = await Promise.all([
      Get("/site", token),
      Get("https://atlas-ov.sys.echosp.link/api/status1", token),
    ]);

    const { data: sites } = siteResponse.data;
    const statusData = Object.values(statusResponse.data);

    // 🧩 Normalize and group interface statuses by device ID
    const deviceStatuses = statusData.reduce((acc, rawItem) => {
      const devid = String(rawItem.devid || "").trim().toUpperCase();
      if (!devid) return acc;
      if (!acc[devid]) acc[devid] = [];
      acc[devid].push({ ...rawItem, status: rawItem.status?.toLowerCase() });
      return acc;
    }, {});

    // 🧮 Compute summarized status per device
    const deviceStatusSummary = {};
    Object.entries(deviceStatuses).forEach(([devid, interfaces]) => {
      const upCount = interfaces.filter((i) => i.status === "up").length;
      const downCount = interfaces.filter((i) => i.status === "down").length;

      let overallStatus = "down";
      if (upCount > 0 && downCount > 0) overallStatus = "updown";
      else if (upCount > 0 && downCount === 0) overallStatus = "up";

      deviceStatusSummary[devid] = {
        devid,
        devname: interfaces[0]?.devname || "",
        status: overallStatus,
        count: upCount,
        date: interfaces[0]?._col0 || "",
        interface: interfaces.map((i) => i.interface).join(", "),
      };
    });

    // 🧩 Merge site info with status data
    const siteObjects = sites.map((site) => {
      const siteId = String(site.SerialNo || "").trim().toUpperCase();
      const match = deviceStatusSummary[siteId];

      const merged = {
        devid: site.SerialNo,
        devname: match?.devname || site.SiteName,
        site_status: match?.status || "down",
        date: match?.date || "",
        interface: match?.interface || "",
        count: match?.count || 0,
        zone: site.Zone,
        siteName: site.SiteName,
        underlay1: site.Underlay1,
        underlay2: site.Underlay2,
      };

      // 🧠 Debugging: Log false-downs to verify causes
      if (!match) {
        console.warn(
          `⚠️ No status data found for site ${site.SiteName} (${site.SerialNo})`
        );
      } else if (match.status === "down" && match.count > 0) {
        console.warn(
          `⚠️ False down detected: ${site.SiteName} (${site.SerialNo}) → interfaces:`,
          deviceStatuses[siteId]
        );
      }

      return merged;
    });

    // 🚫 Filter out any unwanted devices
    const filteredSites = siteObjects.filter(
      (s) => s.devid !== "FGT40FTK2209A1L9"
    );

    // 🧾 Remove duplicates & store
    const uniqueList = Object.values(
      filteredSites.reduce((acc, site) => {
        acc[site.devid] = site;
        return acc;
      }, {})
    );

    localStorage.setItem("dash_data", JSON.stringify(uniqueList));
    setSiteDetails(uniqueList);
    setsites(sites);
  } catch (error) {
    console.error("❌ Error fetching event data:", error);
  } finally {
    setLoading(false);
  }
};

const fetchEventData3 = async () => {
  try {
    setLoading(true);

    // Fetch both APIs concurrently
    const [siteResponse, statusResponse] = await Promise.all([
      Get("/site", token),
      Get("https://atlas-ov.sys.echosp.link/api/status1", token),
    ]);

    const { data: sites } = siteResponse.data;
    const statusData = Object.values(statusResponse.data);

    // Group interface statuses by device
    const deviceStatuses = statusData.reduce((acc, { devid, status, ...rest }) => {
      if (!acc[devid]) acc[devid] = [];
      acc[devid].push({ status, ...rest });
      return acc;
    }, {});

    // Determine overall device status
    const deviceStatusSummary = Object.entries(deviceStatuses).reduce(
      (acc, [devid, interfaces]) => {
        const upCount = interfaces.filter((i) => i.status === "up").length;
        const downCount = interfaces.filter((i) => i.status === "down").length;

        let overallStatus = "down";
        if (upCount > 0 && downCount > 0) overallStatus = "updown";
        else if (upCount > 0 && downCount === 0) overallStatus = "up";

        acc[devid] = {
          devid,
          devname: interfaces[0]?.devname || "",
          status: overallStatus,
          count: upCount,
          date: interfaces[0]?._col0 || "",
          interface: interfaces.map((i) => i.interface).join(", "),
        };
        return acc;
      },
      {}
    );

    // Merge site and status data
    const siteObjects = sites.map((site) => {
      const match = deviceStatusSummary[site.SerialNo];
      return {
        devid: site.SerialNo,
        devname: match?.devname || site.SiteName,
        site_status: match?.status || "down",
        date: match?.date || "",
        interface: match?.interface || "",
        count: match?.count || 0,
        zone: site.Zone,
        siteName: site.SiteName,
        underlay1: site.Underlay1,
        underlay2: site.Underlay2,
      };
    });

    // Filter out unwanted device(s)
    const filteredSites = siteObjects.filter(
      (s) => s.devid !== "FGT40FTK2209A1L9"
    );

    // Deduplicate and store
    const uniqueList = Object.values(
      filteredSites.reduce((acc, site) => {
        acc[site.devid] = site;
        return acc;
      }, {})
    );

    localStorage.setItem("dash_data", JSON.stringify(uniqueList));
    setSiteDetails(uniqueList);
    setsites(sites);
  } catch (error) {
    console.error("Error fetching event data:", error);
  } finally {
    setLoading(false);
  }
};


  const fetchEventData1 = async () => {
    setLoading(true);
    const site_obeject = [];
    let newlist = [];
    Get("/site", token)
      .then(async(response) => {
        const { data } = response.data;
	      console.log(data)

        const sitestatuData_url ='https://atlas-ov.sys.echosp.link/api/status';
        await Get(sitestatuData_url, token)
          .then((status_response) => {
            let statusCount = {};
		  console.log("status",status_response)
            Object.values(status_response.data).forEach((item) => {
              const { devid, status } = item;
              if (status === 'up') {
                if (statusCount[devid]) {
//		console.log(devid, " Mathced in upFGT40FTK2309FHR1")
                  statusCount[devid]++;
                } else {
//		 if (devid="FGT40FTK2309FHR1"){console.log("FGT40FTK2309FHR1 is the same  in false", devid )}
                  statusCount[devid] = 1;
                }
              }
            });
            const uniqueObjects = Object.entries(statusCount).map(([devid, count]) => ({
              devid,
              count,
            }));
            
            const uniqueData = Object.values(status_response.data).reduce((acc, curr) => {
              const devid = curr.devid;
              uniqueObjects.map((obj, index) =>{
                if (curr.devid === obj.devid){
                    if(!acc[curr.devid]){
                      if(obj.count >= 2) {
                        curr.count = obj.count;
                        curr.status = 'up';
                        acc[devid] = curr
                      }
                      if(obj.count === 1) {
                        curr.count = obj.count;
                        curr.status = 'updown';
                        acc[devid] = curr
                      }
                    }
                }
              })
              return acc;
              
            }, {});

            const list_statuses = Object.entries(uniqueData);
            list_statuses.map((site_status_data) => {

              if(data.length > 0) {
                data.map((site) => {
                 if(site.SerialNo == site_status_data[1].devid){
                    site_obeject.push ({
                      devid: site.SerialNo,
                      devname: site_status_data[1].devname || site.SiteName,
                      site_status: site_status_data[1].status|| "down",
                      date: site_status_data[1]._col0 || "",
                      interface: site_status_data[1].interface || "",
                      count: site_status_data[1].count || 0,
                      zone: site.Zone,
                      siteName: site.SiteName,
                      underlay1: site.Underlay1,
                      underlay2: site.Underlay2,
                    })
			 console.log(site.SiteName, "name-0")
                  }

			//else {console.log(site.SiteName, "name")}
			
                })
              }
            })
          
            newlist = [...site_obeject]
		  console.log(newlist, "----------------")
            data.forEach(item => {    
	//	const exists = site_obeject.some((obj) => obj.devid === item.SerialNo);         
//	if (!exists && item.SerialNo !== "FGT40FTK2209A1L9") {
    //newlist.push({
     // devid: item.SerialNo,
     // devname: item.SiteName,
     // site_status: "down",
      //count: 0,
     // date: "",
    //  interface: "",
    //  zone: item.Zone,
    //  siteName: item.SiteName,
   //   underlay1: item.Underlay1,
  //    underlay2: item.Underlay2,
 //   });
//  }   
              if(item.SerialNo !== "FGT40FTK2209A1L9") { 
                if(!site_obeject.includes(item.SerialNo)) {  
                  newlist.push({ 
                   devid: item.SerialNo,
                    devname: item.SiteName,
                    site_status: 'down',
                    count: 0,
                    date: '',
                    interface: '',
                    zone: item.Zone,
                    siteName: item.SiteName,
                    underlay1: item.Underlay1,
                    underlay2: item.Underlay2,
                  })
                }
              }
            })
          })

          let count =0;
          let empty_list =[]
          const uniqueData = Object.values(newlist).reduce((acc, curr) => {
            const devid = curr.devid;
            if (!acc[devid]) {
              acc[devid] = curr;
              empty_list.push(curr)
              count = count + 1;
            }
            localStorage.setItem('dash_data', {...acc});
            return {...acc};
          })
          setSiteDetails(empty_list);
          setsites(data);
          setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const fetchEventData2 = async () => {
  try {
    setLoading(true);

    // Fetch both APIs concurrently
    const [siteResponse, statusResponse] = await Promise.all([
      Get("/site", token),
      Get("https://atlas-ov.sys.echosp.link/api/status1", token),
    ]);

    const { data: sites } = siteResponse.data;
    const statusData = Object.values(statusResponse.data);

    // Count "up" statuses per device
    const statusCount = statusData.reduce((acc, { devid, status }) => {
      if (status === "up") acc[devid] = (acc[devid] || 0) + 1;
      return acc;
    }, {});

    // Deduplicate and assign statuses
    const uniqueDevices = {};
    statusData.forEach((item) => {
      const { devid } = item;
      const count = statusCount[devid] || 0;

      if (!uniqueDevices[devid]) {
        let derivedStatus = "down";
        if (count >= 2) derivedStatus = "up";
        else if (count === 1) derivedStatus = "updown";

        uniqueDevices[devid] = {
          ...item,
          count,
          status: derivedStatus,
        };
      }
    });

    // Merge site data with status data
    const siteObjects = sites.map((site) => {
      const match = uniqueDevices[site.SerialNo];
      return {
        devid: site.SerialNo,
        devname: match?.devname || site.SiteName,
        site_status: match?.status || "down",
        date: match?._col0 || "",
        interface: match?.interface || "",
        count: match?.count || 0,
        zone: site.Zone,
        siteName: site.SiteName,
        underlay1: site.Underlay1,
        underlay2: site.Underlay2,
      };
    });

    // Filter out unwanted device(s)
    const filteredSites = siteObjects.filter(
      (s) => s.devid !== "FGT40FTK2209A1L9"
    );

    // Store unique entries in localStorage
    const uniqueList = Object.values(
      filteredSites.reduce((acc, site) => {
        acc[site.devid] = site;
        return acc;
      }, {})
    );

    localStorage.setItem("dash_data", JSON.stringify(uniqueList));
    setSiteDetails(uniqueList);
    setsites(sites);
  } catch (error) {
    console.error("Error fetching event data:", error);
  } finally {
    setLoading(false);
  }
};


  const groupedData = siteDetails.reduce((acc, item) => {
    const key = item.zone;
    const devid = item.devid;
    if (!acc[key]) {
      acc[key] = [];
    }
    item.zone = key.split(' ').join('')
    acc[key].push(item);
    return {...acc};
  }, {});
  
  const zone3_data = []
  const zone2_data = []
  const zone1_data = []
  const siteGroupedData = siteDetails.map((acc, item) => {
      const zone_keys = acc.zone
      if (zone_keys === 'Zone1'){
        zone1_data.push({acc})
      }if (zone_keys === 'Zone2'){
        zone2_data.push(acc)
      }if (zone_keys === 'Zone3'){
        zone3_data.push(acc)
      }
    })
    
  const zone1Up =[]
  const zone1Down =[]
  const zone1UpDown =[]
  // const zone1Unkown =[]
  if(zone1_data.length > 0){
    const zone1site_details = zone1_data.map((acc, item) =>{
    
      const site_value = acc.acc
      const status = site_value.site_status 
      if( status === 'up' && site_value.count > 1){ 
        zone1Up.push({site_value}) 
      }
      if(status === 'updown') {
        for(let i = 0; i < loadshedingdata.length; i++) {
          if(loadshedingdata[i].SiteName === site_value.devname ){
              site_value.isLoadsheding = 'yes';
              site_value.sheding_time = loadshedingdata[i].start + ' - ' + loadshedingdata[i].end;
          }else 
          {
            site_value.isLoadsheding = ' ';
          }
        }
        zone1UpDown.push({site_value})
      }
      if(status === 'down' || status === '' || site_value < 2 ) {

        for(let i = 0; i < loadshedingdata.length; i++) {
          if(loadshedingdata[i].SiteName === site_value.devname ){
              site_value.isLoadsheding = 'yes';
              site_value.sheding_time = loadshedingdata[i].start + ' - ' + loadshedingdata[i].end;
          }else 
          {
            site_value.isLoadsheding = ' ';
          }
        }
        zone1Down.push({site_value})
      }
    })
  }

  const zone2Up =[]
  const zone2Down =[]
  const zone2UpDown =[]
  // const zone2Unkown =[]
  if(zone2_data.length > 0) {
    const zone2site_details = zone2_data.map((acc, item) =>{
      const site_value = acc
      const status = acc.site_status 
      if( status === 'up'){ 
        zone2Up.push({site_value}) 
      }
      if(status === 'updown') {
        for(let i = 0; i < loadshedingdata.length; i++) {
          if(loadshedingdata[i].SiteName === site_value.devname ){
              site_value.isLoadsheding = 'yes';
              site_value.sheding_time = loadshedingdata[i].start + ' - ' + loadshedingdata[i].end;
          }else 
          {
            site_value.isLoadsheding = ' ';
          }
        }
	zone2UpDown.push({site_value})
      }
      if(status === 'down' ||  status === '') {
        for(let i = 0; i < loadshedingdata.length; i++) {
          if(loadshedingdata[i].SiteName == site_value.devname ){
             site_value.sheding_time = loadshedingdata[i].start + ' - ' + loadshedingdata[i].end; 
	     site_value.isLoadsheding = 'yes'
          }else 
          {
            site_value.isLoadsheding = ' '
          }
        }
        zone2Down.push({site_value})
      }
    })
  }

  const zone3Up =[]
  const zone3Down =[]
  const zone3UpDown =[]
  // const zone3Unkown =[]
  if(zone3_data.length > 0) {
    const zone3site_details = zone3_data.map((acc, item) =>{
      const site_value = acc
      const status = acc.site_status
      if( status === 'up'){ 
        zone3Up.push({site_value}) 
      }
      if(status === 'updown') {
        for(let i = 0; i < loadshedingdata.length; i++) {
          if(loadshedingdata[i].SiteName === site_value.devname ){
              site_value.isLoadsheding = 'yes';
              site_value.sheding_time = loadshedingdata[i].start + ' - ' + loadshedingdata[i].end;
          }else 
          {
            site_value.isLoadsheding = ' ';
          }
        }
	zone3UpDown.push({site_value})
      }
      if(status === 'down' || status === '') {
        for(let i = 0; i < loadshedingdata.length; i++) {
          if(loadshedingdata[i].SiteName == site_value.devname ){
                 site_value.sheding_time = loadshedingdata[i].start + ' - ' + loadshedingdata[i].end;
		 site_value.isLoadsheding = 'yes'
          }else 
          {
          
            site_value.isLoadsheding = ' '
          }
        }
        zone3Down.push({site_value})
      }
    })
  }

  const formatTimestamp = (timestamp) => {
    return moment.unix(timestamp).format('YYYY-MM-DD HH:mm:ss');
  };
  
  const data = [
    ["Sites ",  "TOTAL SITES IN ZONE", "DOWN", "UP-DOWN", "UP"],
    [`Zone 1 - ${zone1_data.length} Sites`, zone1_data.length, zone1Down.length, zone1UpDown.length, zone1Up.length],
    [`Zone 2 - ${zone2_data.length} Sites`, zone2_data.length, zone2Down.length, zone2UpDown.length, zone2Up.length ],
    [`Zone 3 - ${zone3_data.length} Sites`, zone3_data.length, zone3Down.length, zone3UpDown.length, zone3Up.length],
  ];
  
  const zoneSortedList = [
    {id:1 ,length: zone1Down.length, zone: 'zone1', data: zone1Down}, 
    {id:2 ,length: zone2Down.length, zone: 'zone2', data: zone2Down}, 
    {id:3 ,length: zone3Down.length, zone: 'zone3', data: zone3Down}
  ]
  
  const warningsiteSortedList = [
    {id:1 ,length: zone1UpDown.length, zone: 'zone1', data: zone1UpDown}, 
    {id:2 ,length: zone2UpDown.length, zone: 'zone2', data: zone2UpDown}, 
    {id:3 ,length: zone3UpDown.length, zone: 'zone3', data: zone3UpDown}
  ]
  
  const handleZoneView = (event) => {
    history.push('/down', event);
  }
  
  const handleWarningZoneView = (event) => {
    history.push('/updown', event)
  }
  
  const handleBarClick = (chartWrapper, down, updown) => {
    const selection = chartWrapper.getChart().getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const rowIndex = selectedItem.row;
      
      if(rowIndex === 0 && selectedItem.column === 2){
        history.push('/down', down[0]);
      }if(rowIndex === 0 && selectedItem.column === 3){
        history.push('/updown', updown[0]);
      }
      
      if(rowIndex === 1 && selectedItem.column === 2){
        history.push('/down', down[1]);
      }if(rowIndex === 1 && selectedItem.column === 3){
        history.push('/updown', updown[1]);
      }
      
      if(rowIndex === 2 && selectedItem.column === 2){
        history.push('/down', down[2]);
      }if(rowIndex === 2 && selectedItem.column === 3){
        history.push('/updown', updown[2]);
      }
      setSelectedBar(rowIndex);
    }
  };
  
  return loading ? (
    <div style={spinnerContainerStyle}>
      <CircularProgress />
    </div>
  ) : (
  <>
     <Chart
        chartType="Bar"
        width="100%"
        height="400px"
        data={data}
        options={options}
        chartEvents={[
          {
            eventName: "select",
            callback: ({ chartWrapper } ) => handleBarClick(chartWrapper, zoneSortedList, warningsiteSortedList),
          },
        ]}
      />
    <div style={{display: 'flex'}} >
      {zoneSortedList.map((ele, idx) => {
        return(<div key={ele} style={{padding: '0.5rem'}}>
              <Button variant="contained" color="error" onClick={(event) =>{
              handleZoneView(ele)
              }} >Zone{idx+1}  -  {ele.length}</Button>
        </div>)
      })}
    </div>
    
    <div style={{display: 'flex'}} >
      {warningsiteSortedList.map((ele, idx) => {
        return(<div key={ele} style={{padding: '0.5rem'}}>
              <Button variant="contained" color="warning" onClick={(event) =>{
              handleWarningZoneView(ele)
              }} >Zone{idx+1}  -  {ele.length}</Button>
        </div>)
      })}
    </div>
  </>
  )
}

const spinnerContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "200px",
};
